<template>
  <footer>
    <div class="w-full mt-16 xl:mt-24">
      <div class="container flex justify-between py-3 border-t border-au_gray-200 xl:py-6">
        <div>
          <a
            v-if="!loading"
            href="#"
            class="text-sm text-au_blue-600 xl:text-lg cursor-pointer hover:text-au_primary_hover hover:underline"
            @click.prevent="showExitPopup = true"
          >
            {{ $t('components.footer.returnToLH') }}
          </a>
        </div>

        <CancelRedemptionPopup v-model="showExitPopup" />
      </div>
    </div>

    <div class="container flex flex-col py-8 bg-au_primary text-white xl:flex-row xl:justify-between xl:items-center xl:py-10">
      <div class="mb-10 xl:mb-0">
        <div class="servus-logo" />
      </div>
      <nav>
        <ul class="xl:flex xl:justify-start xl:text-lg">
          <li class="pb-2 leading-tight truncate xl:pb-0 xl:mr-8">
            <a
              target="_blank"
              :href="imprintLink"
              class="inline-flex items-center text-white"
            >
              <span class="mr-2">
                <svg width="300" height="300" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-2 h-2 xl:w-3 xl:h-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M51.258 21.75l30.307 30.21H7.81l.01 16.06h73.766L51.183 98.23l11.404 11.363 49.602-49.6L62.6 10.406 51.257 21.75" fill="#fff"/></svg>
              </span>
              {{ $t('components.footer.links.imprint') }}
            </a>
          </li>
          <li class="pb-2 leading-tight truncate xl:pb-0 xl:mr-8">
            <a
              target="_blank"
              :href="privacyLink"
              class="inline-flex items-center text-white"
            >
              <span class="mr-2">
                <svg width="300" height="300" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-2 h-2 xl:w-3 xl:h-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M51.258 21.75l30.307 30.21H7.81l.01 16.06h73.766L51.183 98.23l11.404 11.363 49.602-49.6L62.6 10.406 51.257 21.75" fill="#fff"/></svg>
              </span>
              {{ $t('components.footer.links.privacy') }}
            </a>
          </li>
          <li class="leading-tight truncate">
            <a
              :href="`https://www.austrian.com/xx/${this.$i18n.locale}/legal/voucher-conditions`"
              class="inline-flex items-center text-white"
              target="_blank"
            >
              <span class="mr-2">
                <svg width="300" height="300" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-2 h-2 xl:w-3 xl:h-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M51.258 21.75l30.307 30.21H7.81l.01 16.06h73.766L51.183 98.23l11.404 11.363 49.602-49.6L62.6 10.406 51.257 21.75" fill="#fff"/></svg>
              </span>
              {{ $t('components.footer.links.termsOfUse') }}
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <div class="container flex flex-col items-center py-8 xl:flex-row xl:justify-between xl:py-7">
      <div>
        <div class="austrian-logo" />
      </div>
      <div class="w-56 mt-4 xl:mt-0">
        <img src="~images/psp/star-alliance.png">
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import Vue from 'vue'
import { mixin as clickaway } from 'vue-clickaway'
import CancelRedemptionPopup from '~app/psp/austrian/cancel-redemption-popup.vue'

export default Vue.extend({
  components: {
    CancelRedemptionPopup,
  },

  mixins: [clickaway],

  data(): {
    showExitPopup: boolean;
  } {
    return {
      showExitPopup: false,
    }
  },
  computed: {
    loading(): boolean {
      return this.$store.state.redemptions.loading
    },
    privacyLink(): string {
      if (this.$i18n.locale === 'de') {
        return 'https://www.austrian.com/at/de/datenschutz'
      }

      if (this.$i18n.locale === 'fr') {
        return 'https://www.austrian.com/xx/fr/data-protection'
      }

      return 'https://www.austrian.com/at/en/data-protection'
    },
    imprintLink(): string {
      if (this.$i18n.locale === 'fr') {
        return 'https://www.austrian.com/xx/fr/imprint'
      }

      return `https://www.austrian.com/Info/LegalRegulations/Imprint.aspx?sc_lang=${this.$i18n.locale}&cc=AT`
    },
  },
})
</script>

<style lang="scss" scoped>
.servus-logo {
  width: 132px;
  height: 32px;
  background: url('~images/psp/austrian/servus-logo.svg') 0 0 / 132px 32px no-repeat;
}

.austrian-logo {
  width: 140px;
  height: 20px;
  background: url('~images/psp/austrian/austrian-logo.svg') 0 0 / 140px 20px no-repeat;

  @screen xl {
    width: 160px;
    height: 23px;
    background-size: 160px 23px;
  }
}
</style>
